import './workflow.css';
import flowchart from '../../static/Air Force - Prod.png';
import { Box, Button, Typography } from '@mui/material';

const Workflow = () => {
  return (
    <Box
      sx={{
        padding: '25px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px',
      }}
    >
      <Box>
        <Typography>
          Please use the following Infographic below to help guide you through
          where you need to go or who you need to contact for your specific
          circumstances in regards to the current water issues. We know this may
          not cover everyone’s particular circumstance, please know that we are
          working hard on getting the answers for you as soon as we can!
        </Typography>
      </Box>
      <Box
        sx={{ textDecoration: 'none' }}
        component='a'
        href={flowchart}
        download
      >
        <Button variant='outlined'>Download Flowchart</Button>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <img
          className='workflow'
          src={flowchart}
          alt='Tron Logo'
          height='auto'
          width='auto'
        />
      </Box>
    </Box>
  );
};

export { Workflow };
